export default {
    namespaced: true,

    state: {
        client: {},

        benefits: {},
        benefits_requested: false,

        age_range: {
            min: 21,
            max: 59,
        },

        my_ability_lock: true,

        benefactors: [],
        beneficiaries: [],
        lpp: [],
        types: [],

        resources_loaded: false,

        explorer_options: [],
    },

    getters: {
        getClient(state) {
            return state.client;
        },
        getBenefits(state) {
            return state.benefits;
        },
        getBenefitsRequested(state) {
            return state.benefits_requested;
        },
        getAgeRange(state) {
            return state.age_range;
        },
        getMyAbilityLock(state) {
            return state.my_ability_lock;
        },

        getBenefactor(state) {
            return state.benefactors;
        },
        getBeneficiaries(state) {
            return state.beneficiaries;
        },
        getLpp(state) {
            return state.lpp;
        },

        getResourcesLoaded(state) {
            return state.resources_loaded;
        },

        getExplorerOptions(state) {
            return state.explorer_options;
        },

        getUnlimited(state) {
            return state.benefits_requested && typeof state.benefits.productMaximumIndemnity !== 'undefined' && state.benefits.productMaximumIndemnity.value === 1000000000;
        }
    },

    actions: {
        getResources(context) {
            return new Promise((resolve, reject) => {
                if (context.getters.getResourcesLoaded) {
                    resolve();
                    return false;
                }

                window.axios.post('/calculators/myCoverResources')
                    .then((response) => {
                        context.commit('setBenefactorOptions', response.data.benefactors);
                        context.commit('setBeneficiaryOptions', response.data.beneficiaries);
                        context.commit('setLPPOptions', response.data.lpp);

                        context.commit('setResourcesLoaded', true);

                        resolve();
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error);
                    });
            });

        },
        newQuote(context) {
            const client = {
                age: 35,
                gender: '1',
                smoker: '1',
                education: 2,
                sharia_compliant: false,
                monthly_income: 20000,

                lpp_type: 3,
                minimum_cover: 0,
                benefactor_type: 2,
                include_my_ability: false,
                my_ability_cover_amount: 0,

                value: 0,
                properties: 1,
                property_value: 0,
                value_to_trust: 0,
                term_of_trust: 8,

                client_id: null,
                client_name: '',
                client_type: null,

                quote_name: '',

                my_cover_beneficiary: 2,
                compare_to: 'liberty_life'
            };

            context.commit('setClient', client);
            context.commit('setBenefits', {});
            context.commit('setBenefitsRequested', false);
            context.commit('setMinimumCover');
            context.commit('setMyAbilityLock', true);

            this.commit('calculators/setQuoteId', null);
            this.commit('calculators/setClientRating', 2);
            this.dispatch('calculators/resetAll');
        },

        getBenefits(context, intermediaryId = null) {
            this.commit('calculators/setChecking', true);

            return new Promise((resolve, reject) => {

                window.axios.post('/calculators/myCoverBenefits', {
                    create_for_int: intermediaryId,
                    client: context.getters.getClient,
                    quote_id: this.getters['calculators/getQuoteId'],
                    current_step: this.getters['calculators/getCurrentStep'],
                })
                    .then((response) => {
                        context.commit('setBenefits', response.data.benefits);

                        console.log(response.data.benefits.debug.time);

                        if (typeof response.data.benefits.quoteId !== 'undefined') {
                            this.commit('calculators/setQuoteId', response.data.benefits.quoteId);
                        }

                        context.commit('setBenefitsRequested', true);

                        this.commit('calculators/setChecking', false);

                        resolve();
                    })
                    .catch((error) => {
                        console.error(error);
                        this.commit('calculators/setChecking', false);

                        reject(error);
                    });
            });
        },
        getExplorerOptions(context, force = false) {
            if (context.getters.getExplorerOptions.length && !force) {
                return false;
            }

            let fees = 0;

            if (context.getters.getBenefitsRequested) {
                fees = context.getters.getBenefits.totalFeesRequiringIndemnification.value;
            }

            window.axios.post('/calculators/myCoverExplorerOptions', {
                client: context.getters.getClient,
                fees: fees,
            })
                .then((response) => {
                    context.commit('setExplorerOptions', response.data.options);
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    },

    mutations: {
        setClient(state, client) {
            state.client = client;
        },
        setBenefits(state, benefits) {
            state.benefits = benefits;
        },
        setBenefitsRequested(state, boolean) {
            state.benefits_requested = boolean;
        },

        setMinimumCover(state) {
            let multiplier = 20;

            const ageNextBirthday = state.client.age + 1;

            if ([31, 53].includes(ageNextBirthday)) {
                multiplier = 25;
            }
            if ([32, 52].includes(ageNextBirthday)) {
                multiplier = 30;
            }
            if ([33, 51].includes(ageNextBirthday)) {
                multiplier = 35;
            }
            if ([34, 46, 47, 48, 49, 50].includes(ageNextBirthday)) {
                multiplier = 40;
            }
            if ([35, 45].includes(ageNextBirthday)) {
                multiplier = 45;
            }
            if ([36, 37, 38, 39, 40, 44].includes(ageNextBirthday)) {
                multiplier = 50;
            }
            if ([41, 43].includes(ageNextBirthday)) {
                multiplier = 55;
            }
            if ([42].includes(ageNextBirthday)) {
                multiplier = 60;
            }

            state.client.minimum_cover = Math.round((state.client.monthly_income * multiplier) / 500000) * 500000;
            state.client.my_ability_cover_amount = Math.round((state.client.minimum_cover / 2));
        },

        setMyAbilityLock(state, boolean) {
            state.my_ability_lock = boolean;
        },

        setBenefactorOptions(state, options) {
            state.benefactors = options;
        },
        setBeneficiaryOptions(state, options) {
            state.beneficiaries = options;
        },
        setLPPOptions(state, options) {
            state.lpp = options;
        },

        setResourcesLoaded(state, boolean) {
            state.resources_loaded = boolean;
        },

        setExplorerOptions(state, options) {
            state.explorer_options = options;
        }
    }
}
